import { render, staticRenderFns } from "./create-post.vue?vue&type=template&id=1bf5a800&lang=pug&"
import script from "./create-post.vue?vue&type=script&lang=js&"
export * from "./create-post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports